import { offersListFilterChanged } from '@/events'
import { valueToSortOrder, /*valueToPriceType,*/ valueToViewTypeMap } from '@/modules/offersList'
import QueryString from '@/utils/QueryString'

const $ = require('jquery')

const OFFERS = require('./offers')

// =========================================================================
// Module: Listing Options
// =========================================================================
const listingOptions = {
  Sort () {
    const radioButtonsChangePrice = $('.listing-options__field--price').find('input[type="radio"]')
    const radioButtonsChangeView = $('.listing-options__field--view').find('input[type="radio"]')
    const inputSelect = $('.listing-options__field--sort-by').find('select')
    const offerList = $('.offer-list')
    // Const $listItemsWrapper = offerList.find('.listingWrapper')
    // const $changeView = $('.listing-options__field--view')

    OFFERS.ellipsisInOfferItem()

    function publishState () {
      const sort = valueToSortOrder[document.querySelector('.listing-options__field--sort-by li.selected').dataset.originalIndex]
      /**
       * IG-1507 because of problem with group price this section will be
       * commented-out till group prices will be fine.
       * 
       * 
       * const priceType = valueToPriceType[document.querySelector('.listing-options__field--price .active input[type="radio"]').value]
       */
      const priceType = 'person'
      const viewType = valueToViewTypeMap[document.querySelector('.listing-options__field--view .active input[type="radio"]').value]
      offersListFilterChanged({ orderBy: sort.field, direction: sort.direction, priceType, viewType })
    }

    /*
     Change the list view offers
     */
    radioButtonsChangeView.on('change', function() {
      const $this = $(this)
      const parent = $this.parent()
      const qs = new QueryString()

      radioButtonsChangeView.removeAttr('disabled')
      parent.siblings().removeClass('active')

      OFFERS.ellipsisInOfferItem()

      if ($this.is(':checked')) {
        $this.attr('disabled', 'disabled')
        parent.addClass('active').promise().done(function() {
          publishState()
          if ($this.siblings().hasClass('custom-icon--tiles')) {
            offerList.removeClass('offer-map').addClass('offer-tile')
            $('.listing-options__field--sort-by').show()
            qs.set('TypeViewListing', 'tiles')
          } else if ($this.siblings().hasClass('custom-icon--map')) {
            offerList.removeClass('offer-tile').addClass('offer-map')
            $('.listing-options__field--sort-by').hide()
            qs.set('TypeViewListing', 'map')
          } else {
            offerList.removeClass('offer-tile offer-map')
            $('.listing-options__field--sort-by').show()
            qs.set('TypeViewListing', 'list')
          }
        })
      }
    })
    /*
    Change type of price
     */
    radioButtonsChangePrice.on('change', function() {
      const _ = $(this)
      const parent = _.parent()
      parent.siblings().removeClass('active')
      const qs = new QueryString()

      if (_.is(':checked')) {
        parent.addClass('active').promise().done(function() {
          publishState()
          if (_.siblings().hasClass('custom-icon--man')) {
            if (qs.get('SortOption') != '1') {
              qs.set('SortOption', 0)
            }
          } else {
            if (qs.get('SortOption') != '1') {
              qs.set('SortOption', 5)
            }
          }
        })
      }
    })

    /*
    Sort list view offers
     */
    inputSelect
      .selectpicker({
        'noneSelectedText': 'Brak sortowania',
      })
      .on('changed.bs.select', function(e) {
        publishState()
        const selected = $(e.currentTarget).val()
        new QueryString().set('SortOption', selected)
      })
  },

  ChangeTypeView () {
    const inputRadioChangeView = $('.listing-options__field--view').find('input[type="radio"]')
    const inputRadioLabelList = $('.listing-options__field--view').find('.custom-icon--listing')
    const inputRadioLabelTile = $('.listing-options__field--view').find('.custom-icon--tiles')
    const inputRadioLabelMap = $('.listing-options__field--view').find('.custom-icon--map')

    const qs = new QueryString()

    if (qs.get('TypeViewListing')) {
      inputRadioChangeView.parent().siblings().removeClass('active')
      if (qs.get('TypeViewListing') == 'list') {
        inputRadioLabelList.next('input').attr('checked', 'checked')
        inputRadioLabelList.parent().addClass('active')
      } else if (qs.get('TypeViewListing') == 'tiles') {
        inputRadioLabelTile.parent().addClass('active')
        inputRadioLabelTile.next('input').attr('checked', 'checked')
      } else if (qs.get('TypeViewListing') == 'map') {
        inputRadioLabelMap.next('input').attr('checked', 'checked')
        inputRadioLabelMap.parent().addClass('active')
        $('.listing-options__field--sort-by').hide()
      }
    }
  },
}

module.exports = listingOptions



// WEBPACK FOOTER //
// ./src/modules/listingOptions.js